<template>
  <div class="wrapper">
    <Header class="header" data-title="이용가이드"></Header>
    <div class="container">
      <!-- content(s) -->
      <div id="content">
        <section>
          <div class="titArea ac">
            <h2 class="titGuide">웰몰 이렇게 이용하세요!</h2>
          </div>

          <ul class="ftGuideList">
            <li class="list01">
              <a @click="openPop('webViewPop', 1)">
                <strong class="normal">웰몰 앱사용 가이드</strong>
                <p class="disc">웰몰을 이용해야 하는 이유</p>
              </a>
            </li>
            <li class="list02">
              <a @click="openPop('webViewPop', 2)">
                <strong class="normal">A/S진행 가이드</strong>
                <p class="disc">웰몰 앱으로 손쉽게 A/S진행</p>
              </a>
            </li>
            <li class="list03">
              <a @click="openPop('webViewPop', 3)">
                <strong class="normal">웰몰 음식물청소기 가이드</strong>
                <p class="disc">웰릭스 음식물청소기를 사용하는 방법</p>
              </a>
            </li>
            <!-- li class="list04">
              <a @click="openPop('webViewPop', 4)">
                <strong class="normal">정기배송 가이드</strong>
                <p class="disc">매월 필요한 생필품을 알아서 척척</p>
              </a>
            </li -->
            <li class="list05">
              <a @click="openPop('webViewPop', 5)">
                <strong class="normal">웰몰 이용 가이드</strong>
                <p class="disc">웰몰 100% 이용 하는 꿀팁</p>
              </a>
            </li>
            <!-- <li class="list06">
              <a @click="openPop('webViewPop', 6)">
                <strong class="normal"></strong>
                <p class="disc"></p>
              </a>
            </li> -->
          </ul>
        </section>
      </div>
      <!-- content(e) -->
    </div>
    <!-- container(e) -->
    <footer class="footer"></footer>
    <!-- <WebViewPop v-if="webViewPop" :pageName="pageName" @close="webViewPop = false">
      <div v-html="webView"></div>
    </WebViewPop> -->
  </div>
  <!-- wrapper(e) -->
</template>

<script>
import ApiService from '@/common/api.service';
import WebViewPop from '@/components/popup/WebViewPop';
export default {
  name: 'guide',
  components: { WebViewPop },
  async mounted() {
    this.request = this.$route.params.request;
    // console.log(this.request);
    let webViews = await ApiService.get('common/webView/WB000002');
    this.webViews = webViews.data.result;
    // console.log(this.webViews);
  },
  data: function() {
    return {
      webViewUrl: null,
      pageName: null,
      webViews: [],
      webView: null,
      webViewPop: false,
    };
  },
  methods: {
    openPop: function(name, num, pageName) {
      let idx = num - 1;
      this.pageName = pageName;
      this.webViewUrl = this.webViews[idx].filePath;
      this.pageName = this.webViews[idx].pageName;
      this.$router.push({ name: 'guideDetail' + idx, params: { webViewUrl: this.webViewUrl, pageName: this.pageName } });
      //console.log(this.webViews);
      // if (name == 'webViewPop') {
      //   this.webViewUrl = this.webViews[num - 1].filePath;
      //   this.pageName = this.webViews[num - 1].pageName;
      // }
      // this.webView = '<html><body>test</body></html>';
      // this.webViewPop = true;
      // ApiService.get(this.webViewUrl)
      //   .then(({ data }) => {
      //     console.log(data);
      //     this.webView = data;
      //     this.webViewPop = true;
      //   })
      //   .catch(({ response }) => {
      //     console.log(response);
      //   });
    },
  },
};
</script>
